import {debugLogger} from '@repo/shared/utils/debugLogger'
import {useAtomValue, useSetAtom} from 'jotai'
import {FC, useCallback, useEffect} from 'react'
import {TransitionStatus} from 'react-transition-state'
import {EScene} from '../../types/scene.types'
import {gameStartedState, sceneState, timestampGameStartedState} from '../Store/atoms'
import FrameStore from '../Store/FrameStore'
import {CircleCountdown} from './components/CircleCountDown/CircleCountDown'

const fStore = new FrameStore()

interface ICountdownProps {
  transitionStatus: TransitionStatus
}

export const Countdown: FC<ICountdownProps> = ({transitionStatus}) => {
  const gameStarted = useAtomValue(gameStartedState)
  const setGameStartedTimestamp = useSetAtom(timestampGameStartedState)
  const setScene = useSetAtom(sceneState)

  const onCountdownEnd = useCallback(() => {
    const timestamp = Date.now() + (fStore.getServerTimeDiff() ?? 0)

    setGameStartedTimestamp(timestamp)
    setScene(EScene.STARTED)
  }, [setScene])

  /**
   * Enter and leave states
   */
  useEffect(() => {
    if (transitionStatus === 'entered') {
      debugLogger({
        message: 'Enter state',
        tag: 'Countdown',
      })
    } else if (transitionStatus === 'exiting') {
      debugLogger({
        message: 'Exit state',
        tag: 'Countdown',
      })
    }
  }, [transitionStatus])

  if (!gameStarted) {
    return null
  }

  return (
    <CircleCountdown
      countdownFromSeconds={gameStarted?.countdownFromSeconds}
      startTime={gameStarted?.startTime}
      serverTimeDiff={fStore.getServerTimeDiff()}
      onEnd={onCountdownEnd}
    />
  )
}
